import React from 'react';
import { Container, Item, Termo } from "./styles";
import Facebook from '../../assets/facebook.png';
import Instagram from '../../assets/instagram.png';
import Twitter from '../../assets/twitter.png';
import Youtube from '../../assets/youtube.png';
import Linkedin from '../../assets/linkedin.png';
import Message from '../../assets/message.png';
import Whatsapp from '../../assets/whatsapp.png';
const urlApi = "https://imobiliaria-jeff.netlify.app/";

const Footer = () => {
    return (
        <Container>
            <Item>
                <a href={urlApi}><img className='facebook' src={Facebook} alt="Icone do Logo do Facebook" /></a>
                <a href={urlApi}><img className='instagram' src={Instagram} alt="Icone do Logo do Instagram" /></a>
                <a href={urlApi}><img className='twitter' src={Twitter} alt="Icone do Logo do Twitter" /></a>
                <a href={urlApi}><img className='youtube' src={Youtube} alt="Icone do Logo do Youtube" /></a>
                <a href={urlApi}><img className='linkedin' src={Linkedin} alt="Icone do Logo do Linkedin" /></a>
                <a href={urlApi}><img className='whatsapp' src={Whatsapp} alt="Icone do Logo do Whatsapp" /></a>
                <a href={urlApi}><img className='message' src={Message} alt="Icone de mensagem" /></a>
            </Item>
            <Termo>
                <a href={urlApi}><span>Termo de Uso</span></a>
                <p>&#8226;</p>
                <a href={urlApi}><span>Política de Privacidade</span></a>
                <p>&#8226;</p>
                <a href={urlApi}><span>Política de Cookies</span></a>
            </Termo>
        </Container>
    )
}

export default Footer;
